import React from 'react';
import { routes } from 'constants/config';

export default function BulkImportCanceled(props) {
  return (
    <div>
      <p>
        {t('user_imports.canceled.summary') + ' '}
        {t('user_imports.canceled.note')}
        <br />
        {t('user_imports.canceled.redirect_note') + ' '}
        <a className="ButtonLink" href={routes.NEW_BULK_IMPORT}>
          {t('user_imports.canceled.redirect_link_text')}
        </a>
      </p>
    </div>
  );
}
